import { MIN_LENGTH_FOR_NSN as e, VALID_DIGITS as _, PLUS_CHARS as t, VALID_PUNCTUATION as E } from "./atoms-v2794.js";
import r from "./atoms-v2795.js";
var n = "[" + _ + "]{" + e + "}", I = "[" + t + "]{0,1}(?:[" + E + "]*[" + _ + "]){3,}[" + E + _ + "]*", P = new RegExp("^[" + t + "]{0,1}(?:[" + E + "]*[" + _ + "]){1,2}$", "i"), R = I + // Phone number extensions
"(?:" + r() + ")?", T = new RegExp(
  // Either a short two-digit-only phone number
  "^" + n + "$|^" + R + "$",
  "i"
);
function A(N) {
  return N.length >= e && T.test(N);
}
function o(N) {
  return P.test(N);
}
export {
  I as VALID_PHONE_NUMBER,
  R as VALID_PHONE_NUMBER_WITH_EXTENSION,
  A as default,
  o as isViablePhoneNumberStart
};
